module.exports = __webpack_public_path__ + "img/jjin_final_4.768526a2.jpg";